"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/AUFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_15)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_15`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#10338C"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.593 11.9789C9.61405 11.9579 9.62809 11.9368 9.64914 11.9158C9.6351 11.9368 9.61405 11.9579 9.593 11.9789ZM7.193 14.9193L7.96493 16.5263L9.69826 16.1263L8.92633 17.7263L10.3228 18.8351L8.58247 19.228L8.58949 21.0105L7.193 19.8947L5.80352 21.0105L5.81054 19.228L4.07019 18.8351L5.46668 17.7263L4.68773 16.1263L6.42809 16.5263L7.193 14.9193ZM21.0807 16.9193L21.4456 17.6842L22.2737 17.4947L21.9018 18.2596L22.5684 18.7859L21.7404 18.9684V19.8245L21.0807 19.2912L20.414 19.8245L20.4211 18.9684L19.593 18.7859L20.2597 18.2596L19.8877 17.4947L20.7158 17.6842L21.0807 16.9193ZM17.6702 8.77891L18.0351 9.54383L18.8632 9.35435L18.4912 10.1193L19.1579 10.6456L18.3298 10.8351V11.6842L17.6702 11.1508L17.0035 11.6842L17.0105 10.8351L16.1755 10.6456L16.8421 10.1193L16.4702 9.35435L17.2983 9.54383L17.6702 8.77891ZM21.0807 4.1333L21.4456 4.89821L22.2737 4.70874L21.9018 5.47365L22.5684 5.99997L21.7404 6.18944V7.03856L21.0807 6.50523L20.414 7.03856L20.4211 6.18944L19.593 5.99997L20.2597 5.47365L19.8877 4.70874L20.7158 4.89821L21.0807 4.1333ZM24.0632 7.62102L24.4281 8.38593L25.2562 8.19646L24.8842 8.96137L25.5509 9.48769L24.7228 9.67014V10.5263L24.0632 9.99295L23.3965 10.5263V9.67014L22.5684 9.48769L23.2351 8.96137L22.8632 8.19646L23.6912 8.38593L24.0632 7.62102ZM21.9298 11.6842L22.2176 12.5754H23.1509L22.393 13.1228L22.6877 14.014L21.9298 13.4596L21.1719 14.014L21.4597 13.1228L20.7088 12.5754H21.6421L21.9298 11.6842Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.8807 0V2.14737L8.71577 3.90877H11.8807V8.07018H7.73332L11.8807 10.3719V11.9789H10.007L4.8491 9.10877V11.9789H0.947351V8.56842L-5.18598 11.9789H-6.08423V9.83158L-2.9123 8.07018H-6.08423V3.90877H-1.93686L-6.08423 1.6V0H-4.21054L0.947351 2.86316V0H4.8491V3.41053L10.9895 0H11.8807Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.02103 0H1.77542V4.86316H-6.08423V7.10877H1.77542V11.9789H4.02103V7.10877H11.8807V4.86316H4.02103V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.84912 8.07007L11.8807 11.9788V10.8701L6.8421 8.07007H4.84912Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.84912 8.07007L11.8807 11.9788V10.8701L6.8421 8.07007H4.84912Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.8491 8.07007L11.8807 11.9788V10.8701L6.84209 8.07007H4.8491ZM-1.03861 8.07007L-6.08423 10.8701V11.9788L0.947351 8.07007H-1.03861Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0.947351 3.90877L-6.08423 0V1.10175L-1.03861 3.90877H0.947351Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0.947351 3.90877L-6.08423 0V1.10175L-1.03861 3.90877H0.947351Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0.947351 3.90877L-6.08423 0V1.10175L-1.03861 3.90877H0.947351ZM6.84209 3.90877L11.8807 1.10175V0L4.8491 3.90877H6.84209Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_15`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as AUFlag };
